<div ng-controller="filterCollectionsController as vm" class="sieves-list">
    <div class="list-filter list-filter-tools" ng-show="vm.showFilter">
        <div centuri-list-filter class="list-filter-elements" config="vm.filterConfig" callback="vm.filterCallback"></div>
    </div>
    <div id="managed-component"></div>
</div>